export default {
    fire() {
        $('.group-none').hide();

        const selectLevel = $('select[name="formation[level]"]');
        const selectSituation = $('select[name="formation[situation]"]');
        const selectCurrent = $('select[name="formation[current]"]');
        const inputCourse = $('input[name="formation[course][name]"]');
        const inputInstitution = $('input[name="formation[course][institution]"]');
        const selectTime = $('select[name="formation[course][time]"]');
        const inputYearConclusion = $('input[name="formation[course][year_conclusion]"]');
        const inputComplement = $('input[name="formation[course][complement]"]');
        const selectPosHas = $('select[name="formation[pos][has]"]');
        const inputPosCourse = $('input[name="formation[pos][course]"]');
        const inputPosInstitution = $('input[name="formation[pos][institution]"]');
        const inputPosYearConclusion = $('input[name="formation[pos][year_conclusion]"]');


        // Groups
        const groupSituation = $('#group-situation');
        const groupCurrent = $('#group-current');
        const groupCourse = $('#group-course');
        const groupInstitution = $('#group-institution');
        const groupTime = $('#group-time');
        const groupYearConclusion = $('#group-year-conclusion');
        const groupComplement = $('#group-complement');
        const groupPosHas = $('#group-pos-has');
        const groupPosCourse = $('#group-pos-course');
        const groupPosInstitution = $('#group-pos-institution');
        const groupPosYearConclusion = $('#group-pos-year-conclusion');

        function disableCurrent() {
            groupCurrent.hide();
            selectCurrent.attr('disabled', true);
        }

        function enableCurrent() {
            let options = `
                <option disabled selected></option>
                <option value="1">Sim</option>
                <option value="0">Não</option>
            `;
            selectCurrent.html(options);
            selectCurrent.attr('disabled', false);
            groupCurrent.show();
        }

        function disableCourse() {
            groupCourse.hide();
            inputCourse.val('');
            inputCourse.attr('disabled', true);
        }

        function enableCourse() {
            groupCourse.show();
            inputCourse.attr('disabled', false);
        }

        function disableTime() {
            groupTime.hide();
            selectTime.attr('disabled', true);
        }

        function enableTime() {
            let options = `
                <option disabled selected></option>
                <option value="1">Manhã</option>
                <option value="2">Tarde</option>
                <option value="3">Noite</option>
            `;
            selectTime.html(options);
            selectTime.attr('disabled', false);
            groupTime.show();
        }

        function disableInstitution() {
            groupInstitution.hide();
            inputInstitution.val('');
            inputInstitution.attr('disabled', true);
        }

        function enableInstitution() {
            groupInstitution.show();
            inputInstitution.attr('disabled', false);
        }

        function disableYearConclusion() {
            groupYearConclusion.hide();
            inputYearConclusion.val('');
            inputYearConclusion.attr('disabled', true);
        }

        function enableYearConclusion() {
            groupYearConclusion.show();
            inputYearConclusion.attr('disabled', false);
        }

        function disableComplement() {
            groupComplement.hide();
            inputComplement.val('');
            inputComplement.attr('disabled', true);
        }

        function enableComplement() {
            groupComplement.show();
            inputComplement.attr('disabled', false);
        }

        //Pos
        function disablePosHas() {
            groupPosHas.hide();
            selectPosHas.attr('disabled', true);
        }

        function enablePosHas() {
            let options = `
                <option disabled selected></option>
                <option value="1">Sim</option>
                <option value="0">Não</option>
            `;
            selectPosHas.html(options);
            selectPosHas.attr('disabled', false);
            groupPosHas.show();
        }

        function disablePosCourse() {
            groupPosCourse.hide();
            inputPosCourse.val('');
            inputPosCourse.attr('disabled', true);
        }

        function enablePosCourse() {
            groupPosCourse.show();
            inputPosCourse.attr('disabled', false);
        }

        function disablePosInstitution() {
            groupPosInstitution.hide();
            inputPosInstitution.val('');
            inputPosInstitution.attr('disabled', true);
        }

        function enablePosInstitution() {
            groupPosInstitution.show();
            inputPosInstitution.attr('disabled', false);
        }

        function disablePosYearConclusion() {
            groupPosYearConclusion.hide();
            inputPosYearConclusion.val('');
            inputPosYearConclusion.attr('disabled', true);
        }

        function enablePosYearConclusion() {
            groupPosYearConclusion.show();
            inputPosYearConclusion.attr('disabled', false);
        }

        selectLevel.change(function(){
            let options;
            if($(this).val() == '1' || $(this).val() == '2') {
                options = `
                    <option disabled selected></option>
                    <option value="1">Completo</option>
                    <option value="2">Incompleto</option>
                    <option value="3">Cursando</option>
                `;
            } else if($(this).val() == '3' || $(this).val() == '4'){
                options = `
                    <option disabled selected></option>
                    <option value="1">Completo</option>
                    <option value="3">Cursando</option>
                    <option value="4">Trancado</option>
                `;
            }

            selectSituation.html(options);
            groupSituation.show();

            disableCurrent();
            disableCourse();
            disableTime();
            disableInstitution();
            disableYearConclusion();
            disableComplement();
            disablePosHas();
            disablePosCourse();
            disablePosInstitution();
            disablePosYearConclusion();
        });

        selectSituation.change(function(){
            let level = selectLevel.val();
            let situation = $(this).val();
            if(level == '1' || level == '2') {
                enableCurrent();
                disableCourse();
                disableYearConclusion();
            } else if(level == '3' || level == '4') {
                disableCurrent();
                disableCourse();
                disableTime();
                disableInstitution();
                disableYearConclusion();
                disableComplement();
                disablePosHas();
                disablePosCourse();
                disablePosInstitution();
                disablePosYearConclusion();
                if(level == '3' && situation == '1') {
                    enableCourse();
                    enableInstitution();
                    enableYearConclusion();
                    enableComplement();
                } else if(level == '4' && situation == '1') {
                    enableCourse();
                    enableInstitution();
                    enableYearConclusion();
                    enablePosHas();
                } else if(situation == '3') {
                    enableCourse();
                    enableInstitution();
                    enableYearConclusion();
                } else if(situation == '4') {
                    enableCourse();
                    enableInstitution();
                }
            }
        });

        selectCurrent.change(function(){
            if($(this).val() == '1') {
                enableCourse();
                enableTime();
            } else {
                disableCourse();
                disableTime();
            }
        });

        selectPosHas.change(function(){
            if($(this).val() == '1') {
                enablePosCourse();
                enablePosInstitution();
                enablePosYearConclusion();
            } else {
                disablePosCourse();
                disablePosInstitution();
                disablePosYearConclusion();
            }
        });
    },
  };
  


// WEBPACK FOOTER //
// ./scripts/components/work-formation.js